/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_SecretInputs */

const en_entity_secret = /** @type {(inputs: Entity_SecretInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Secret`)
};

const de_entity_secret = /** @type {(inputs: Entity_SecretInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geheimnis`)
};

/**
* | output |
* | --- |
* | "Secret" |
*
* @param {Entity_SecretInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const entity_secret = /** @type {((inputs?: Entity_SecretInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_SecretInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_secret(inputs)
	return de_entity_secret(inputs)
});